/** Espelha LancarFinanceiroVendaRequest do OrquestradorVendas (POST ProcessoVenda/idVenda/{id}/financeiro/lancar). */
export class LancarFinanceiroVendaRequest {
    /** Gerar os boletos das parcelas com forma boleto e conta conectada (custo de bilhetagem). */
    gerarBoletos: boolean = false;
}
